import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { class: "d-flex align-center mr-2" }
const _hoisted_3 = {
  key: 1,
  class: "text-subtitle-1"
}

import { ref } from 'vue'

import GlobalSearchDialog from './GlobalSearchDialog.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppBar2',
  props: {
    drawer: { type: Boolean },
    toggleDrawer: { type: Function },
    user: {},
    theme: {}
  },
  emits: ['toggle-theme', 'logout'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit
const shortcutItems = [
    { icon: 'mdi-calendar-outline', title: 'Calendar', subtitle: 'Appointments' },
    { icon: 'mdi-file-document-outline', title: 'Invoice App', subtitle: 'Manage Accounts' },
    { icon: 'mdi-account-outline', title: 'Users', subtitle: 'Manage Users' },
    { icon: 'mdi-shield-account', title: 'Role Management', subtitle: 'Permission' },
    { icon: 'mdi-chart-pie', title: 'Dashboard', subtitle: 'Analytics' },
    { icon: 'mdi-cog-outline', title: 'Settings', subtitle: 'Account Settings' },
]
// Active section tracking
const activeSection = ref('Dashboards')
const globalSearchVisible = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    class: "bg-background pt-1",
    elevation: "0"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_app_bar_nav_icon, {
          class: "ml-2",
          variant: "text",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggleDrawer()), ["stop"]))
        }),
        _createVNode(_component_v_img, {
          src: "/path-to-materio-logo.svg",
          alt: "Materio",
          "max-width": "120",
          class: "ml-4"
        })
      ]),
      _createVNode(_component_v_spacer),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_btn, {
          icon: "",
          variant: "text",
          class: "mx-1",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('toggle-theme')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.theme === 'myCustomDarkTheme' ? 'mdi-white-balance-sunny' : 'mdi-moon-waning-crescent'), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_menu, {
          "close-on-content-click": false,
          location: "bottom"
        }, {
          activator: _withCtx(({ props: menuProps }) => [
            _createElementVNode("div", _mergeProps(menuProps, { class: "d-flex align-center mx-2 cursor-pointer" }), [
              _createVNode(_component_v_avatar, {
                size: "32",
                color: "primary",
                class: "mr-2"
              }, {
                default: _withCtx(() => [
                  (props.user?.avatar)
                    ? (_openBlock(), _createBlock(_component_v_img, {
                        key: 0,
                        src: props.user.avatar
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(props.user?.name?.substring(0, 1) ?? '?'), 1))
                ]),
                _: 1
              }),
              _createVNode(_component_v_badge, {
                color: "success",
                dot: "",
                "offset-x": "2",
                "offset-y": "2",
                location: "bottom end",
                bordered: ""
              })
            ], 16)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              "min-width": "300",
              class: "pa-3",
              elevation: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, {
                      subtitle: props.user?.email,
                      title: props.user?.name
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          class: "mx-3",
                          icon: "mdi-account-circle",
                          to: "/user",
                          variant: "text"
                        })
                      ]),
                      _: 1
                    }, 8, ["subtitle", "title"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      rounded: "",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('logout')))
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode("Desconectar")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(GlobalSearchDialog, {
        modelValue: globalSearchVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((globalSearchVisible).value = $event))
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})